import React, {Component} from 'react';
import PageHeader from '../components/Headers/PageHeader';
import {connect} from 'react-redux';
import Divider from "../gadgets/Divider";
import {Link} from 'react-router-dom';
import Image from "../components/Image";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Helmet} from 'react-helmet';

class TeamPage extends Component {
    render() {
        const headerContent = {
            tag: 'Check out the',
            title: 'd18 Team',
            description: ''
        };

        return (
            <div className={'container'}>
                <Helmet>
                    <title>Team • D18</title>
                </Helmet>
                <PageHeader color={'blue'} content={headerContent}/>
                {this.props.team.map((member, i) => {
                    if (i % 2 === 0) {
                        return (
                            <section key={i}>
                                <div className={'grid content__flex'}>
                                    <div className={'col--6 col--center info'}>
                                        <div className={'content'}>
                                            <div className={'content__section'}>
                                                <h5 className={"sub-category"}>{member.roles[0] ? member.roles.join(' | ') : ''}</h5>
                                                <h2>{member.fullName}</h2>
                                                <Divider color={'blue'} type={'short'}/>
                                            </div>
                                            <div className={'content__section'}>
                                                <div>
                                                    {member.bio}
                                                </div>
                                            </div>
                                            <div className={'content__section'}>
                                                {member.graduate ? (
                                                    <Link to={
                                                        {
                                                            pathname: `/team/${member.unikey}`,
                                                            state: {modal: true}
                                                        }
                                                    }>
                                                        <div className={'content__link'}>
                                                            <div className={"link"}>
                                                                <FontAwesomeIcon className={'icon icon--small'}
                                                                                 icon={'info-circle'}/>
                                                                View more info

                                                            </div>
                                                        </div>
                                                    </Link>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                    <div className={'col--6 image-on-top'}>
                                        {member.graduate ? (
                                            <Link to={
                                                {
                                                    pathname: `/team/${member.unikey}`,
                                                    state: {modal: true}
                                                }
                                            }>
                                                <Image src={member.image.thumb} aspectRatio={'4:3'} cover shadow/>
                                            </Link>
                                        ) : (<Image src={member.image.thumb} aspectRatio={'4:3'} cover shadow/>)}
                                    </div>
                                </div>
                            </section>
                        )
                    }
                    else {
                        return (
                            <section key={i} className={"section--white"}>
                                <div className={'grid'}>
                                    <div className={'col--6'}>
                                        {member.graduate ? (
                                            <Link to={
                                                {
                                                    pathname: `/team/${member.unikey}`,
                                                    state: {modal: true}
                                                }
                                            }>
                                                <Image src={member.image.thumb} aspectRatio={'4:3'} cover shadow/>
                                            </Link>
                                        ) : (<Image src={member.image.thumb} aspectRatio={'4:3'} cover shadow/>)}
                                    </div>
                                    <div className={'col--6 col--center'}>
                                        <div className={'content'}>
                                            <div className={'content__section'}>
                                                <h5 className={"sub-category"}>{member.roles[0] ? member.roles.join(' | ') : ''}</h5>
                                                <h2>{member.fullName}</h2>
                                                <Divider color={'blue'} type={'short'}/>
                                            </div>
                                            <div className={'content__section'}>
                                                <div>
                                                    {member.bio}
                                                </div>
                                            </div>
                                            <div className={'content__section'}>
                                                {member.graduate ? (
                                                    <Link to={
                                                        {
                                                            pathname: `/team/${member.unikey}`,
                                                            state: {modal: true}
                                                        }
                                                    }>
                                                        <div className={'content__link'}>
                                                            <div className={"link"}>
                                                                <FontAwesomeIcon className={'icon icon--small'}
                                                                                 icon={'info-circle'}/>
                                                                View more info

                                                            </div>
                                                        </div>
                                                    </Link>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        )
                    }
                })}
            </div>
        )
    }
}

const MapStateToProps = (state) => ({
    team: state.team,
});
export default connect(MapStateToProps)(TeamPage);